import React from "react";
import WComponent from "../../../../../../../common/WComponent";

class SearchableSelect extends WComponent {
	state = { search: "", showAll: false };

	render() {
		let { question, options, onSelect } = this.props;
		let { search, showAll } = this.state;

		let filtered = search
			? options.filter(function (opt) { return opt.label.toLowerCase().includes(search.toLowerCase()); })
			: options;

		let maxVisible = 8;
		let visible = showAll ? filtered : filtered.slice(0, maxVisible);
		let hasMore = filtered.length > maxVisible && !showAll;

		return (
			<div className="afs-review__exec-prompt">
				<span className="afs-review__exec-prompt-question">{question}</span>
				<input
					type="text"
					className="afs-review__searchable-input"
					placeholder={"Search " + options.length + " accounts..."}
					value={search}
					onChange={(e) => this.update({ search: e.target.value, showAll: false })}
				/>
				<div className="afs-review__searchable-results">
					{visible.length === 0 && (
						<div className="afs-review__searchable-empty">No accounts match "{search}"</div>
					)}
					{visible.map(function (option) {
						return (
							<button key={option.id} className="afs-review__exec-prompt-btn" onClick={function () { onSelect(option.id); }}>
								{option.label}
							</button>
						);
					})}
					{hasMore && (
						<button className="afs-review__searchable-show-more" onClick={() => this.update({ showAll: true })}>
							Show all {filtered.length} results
						</button>
					)}
				</div>
				{search && filtered.length > 0 && (
					<div className="afs-review__searchable-count">{filtered.length} of {options.length} accounts</div>
				)}
			</div>
		);
	}
}

export default SearchableSelect;
